import script from "./BlockNewsletter.vue?vue&type=script&lang=js"
export * from "./BlockNewsletter.vue?vue&type=script&lang=js"

import "./BlockNewsletter.vue?vue&type=style&index=0&id=25b7a54d&lang=sass"

const __exports__ = script;

export default __exports__